<template>
  <div class="add-person-condition-modal">
    <div v-if="loadModal" class="modal modal-mask">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header div-responsive">
            <div class="modal-title">
              <h1>{{ isEdit ? 'Edit Person Conditions' : 'Add Person Conditions' }}</h1>
            </div>
            <button type="button" class="close-icon" @click="handleModal($event)" data-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body div-responsive">
            <form style="font-size: 14px;">
              <div class="form-group">
                <input type="text" v-model="condition" maxlength="64" :class="hasError && conditionNameError ? 'is-invalid' : ''" class="textbox" placeholder="Enter a Person Condition" />
                <div v-if="hasError && conditionNameError" class="text-danger">{{ conditionNameError }}</div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="icon-group right-float-element">
                    <v-btn class="white-button" @click="handleModal($event)" dark>Cancel</v-btn>
                    <v-btn @click="callSave" id="savebutton" dark>Save</v-btn>
                  </div>
                </div>
              </div>

              <div class="alert alert-success hidden-element">
                <a class="close" title="close">×</a>
                <b>Success:</b> {{ successMessage }}
              </div>
              <div class="alert alert-danger hidden-element">
                <a class="close" title="close">×</a>
                <b>Error:</b> {{ errorMessage }}
              </div>

            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import utilities from '@/assets/js/utilities'
  import store from "../store";

  export default {
    name: 'AddPersonConditionModal',
    data() {
      return {
        loadModal: false,
        condition: '',
        successMessage: '',
        errorMessage: '',
        isEdit: false,
        selectedItem: '',
        hasError: false,
      }
    },
    computed: {
      user() {
        return this.$store.getters['user/getUser'];
      },
      conditionNameError() {
        const s = String(this.condition || '').trim()
        if (!s) {
          return 'Name is required.'
        }
        if (s.length > 64) {
          return 'Name must not exceed 64 characters.'
        }
        if (!/(?=.*[A-Za-z])/.test(s)) {
          return 'Name must include at least one English letter.'
        }
        if (!/^[A-Za-z\s\-\/()]+$/.test(s)) {
          return 'Name may only contain English letters, spaces, hyphens (-), forward slashes (/), and parentheses ( ).'
        }
        return ''
      },
    },
    methods: {
      handleModal(e) {
        this.loadModal = !this.loadModal
        if (this.loadModal) {
          $('html').addClass('modal-mask-open')
        } else {
          $('html').removeClass('modal-mask-open')
        }
      },

      async callSave() {
        this.hasError = false
        if (this.conditionNameError) {
          this.hasError = true
          return
        }
        this.condition = String(this.condition || '').trim()
        this.$store.dispatch("loading/setLoadComponent", true)
        if (!this.isEdit) {
          var params = {
            ConditionName: this.condition,
            UserID: this.user.id,
            Username: this.user.name,
          }
          var condition = await utilities.postPersonCondition(params)
          if (condition) {
            this.$store.dispatch('personConditions/setConditions', null)
            this.$parent.loadData()
            this.successMessage = "Person Condition Added successfully."
            utilities.showAlert(".alert-success")
            setTimeout(() => {
              this.handleModal()
            }, 1000)
          }

        } else {
          var params = {
            ConditionName: this.condition,
          }
          var condition = await utilities.putPersonCondition(this.selectedItem.PersonConditionID, params)
          if (condition) {
            this.$store.dispatch('personConditions/setConditions', null)
            this.$parent.loadData()
            this.successMessage = "Person Condition Updated successfully."
            utilities.showAlert(".alert-success")
            setTimeout(() => {
              this.handleModal()
            }, 1000)
          }
        }

        this.$store.dispatch("loading/setLoadComponent", false)
      },

      editItem(item) {
        this.selectedItem = item
        this.condition = item.ConditionName
      },

      // callPostBookingNoteAPI() {
      //   var params = {
      //     Note: this.note,
      //     NoteDateTime: moment().format('YYYY-MM-DD HH:mm:ss'),
      //     UserID: this.$parent.user.id,
      //     Username: this.$parent.user.name,
      //     BookingID: this.bookingProps.id,
      //     InternalOnly: this.internalOnly,
      //   }
      //   var callback = (response) => {
      //     try {
      //       var allNote = this.bookingProps.bookingNotes
      //       var newNote = {}
      //       newNote = {
      //         note: this.note,
      //         noteDateTime: moment().format('YYYY-MM-DD HH:mm:ss'),
      //         id: response,
      //         userName: this.user.name,
      //         userId: this.user.id,
      //         deleted: false,
      //         internalOnly: this.internalOnly,
      //       }
      //       allNote.push(newNote)
      //       this.$parent.booking.bookingNotes = allNote
      //       this.$parent.setBookingNoteAndAction()
      //       this.$parent.noteKey += 1
      //       this.handleModal()
      //     } catch (e) {}
      //   }
      //   $('#savebutton').prop('disabled', false)
      //   return utilities.postBookingNote(params, callback)
      // },

      // callPutClientNoteAPI() {
      //   var params = {
      //     ClientID: this.clientNote.clientId,
      //     ClientNoteID: this.clientNote.clientNoteId,
      //     Note: this.note,
      //     NoteDateTime: moment().format('YYYY-MM-DD HH:mm:ss'),
      //     UserID: this.$parent.user.id,
      //     Username: this.$parent.user.name,
      //     InternalOnly: this.internalOnly,
      //   }
      //   var callback = (response) => {
      //     this.$parent.getClientNotes()
      //     this.handleModal()
      //   }
      //   $('#savebutton').prop('disabled', false)
      //   return utilities.putClientNote(params, callback)
      // },
    },
    mounted() {},
  }
</script>
